import NewUlcdCom from './src/main';

/* istanbul ignore next */
NewUlcdCom.install = function(Vue) {
  Vue.component(NewUlcdCom.name, NewUlcdCom);
};

export default NewUlcdCom;
